module.exports = __webpack_public_path__ + "static/leader-step3.2c5bbc29.png";